const noop = (): void => {
    //Do nothing
};

export { noop };
